export const REPRINTREASONS = {
    'HP' : {
        name: 'HP',
        problem: [
            { name: 'Defecto de impresion',
              description: [
                'Defecto de impresion BID Yellow',
                'Defecto de impresion BID Magenta',
                'Defecto de impresion BID Cyan',
                'Defecto de impresion BID Negro',
                'Defecto de impresion Mantilla',
                'Defecto de impresion PIP',
                'Defecto de impresion CPR',
                'Defecto de impresion Charge roller',
                'Defecto de impresion Papel de Impresion',
                'Variacion de tono entre hojas, lineas & ordenes',
                'Anclaje (La tinta no se adhiere al papel)',
                'Calibracion CPR',
                'Impresion fantasma - sombras en la imagen',
                'Impresión con manchas',
                'Incorrecto anclaje de tinta'
                ]
            },
            {
                name: 'Set up',
                description : [
                    'Ajuste de Imagen (DUPLEX)'
                ]
            },
            {
                name: 'Defecto de corte',
                description : [
                    'Ajuste de Centrado (Material precortado)'
                ]
            },
            {
                name: 'Producto incorrecto',
                description : [
                    'Impresion en sustrato incorrecto'
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Impresiones dañadas durante el proceso',
                    'Impresión sin movimiento por mucho tiempo',
                    'Batch sin movimiento por mucho tiempo'
                ]
            },
            {
                name: 'Materiales',
                description: [
                    'Incorrecto anclaje de primer'
                ]
            }
        ],
    },
    'Horizon' : {
        name: 'Horizon',
        problem: [
            {
                name: 'Defecto de corte',
                description: [
                    'Fallo prueba de ajedrez - Falta de presion',
                    'Fallo prueba de ajedrez  - Dado dañado',
                    'Corte con dado incorrecto',
                    'Descentrado',
                    'Se recibe dado dañado',
                    'Dado dañado durante el proceso',
                    'Corte profundo - Liner perforado',
                    'Programa de corte incorrecto',
                    'Rebaba- residuos en los bordes del corte',
                    'Tipo de corte mezclado en el trabajo (Laser/Horizon)'
                ]
            },
            {
                name: 'Materiales',
                description: [
                    'Atoramiento'
                ]
            },
            {
                name: 'Set up',
                description: [
                    'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
                ]
            },
        ]        
    },
    // 'Duplo' : {
    //     name: 'Duplo',
    //     problem: [
    //         {
    //             name: 'Defecto de corte',
    //             description: [
    //                 'Descentrado'
    //             ]
    //         },
    //         {
    //             name: 'Materiales',
    //             description: [
    //                 'Atoramiento'
    //             ]
    //         },
    //         {
    //             name: 'Estetico',
    //             description: [
    //                 'Daño material (tinta negra)'
    //             ]
    //         },
    //         {
    //             name: 'Set up',
    //             description: [
    //                 'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
    //             ]
    //         },
    //     ]        
    // },
    'Amiga 36' : {
        name: 'Amiga 36',
        problem: [
            {
                name: 'Defecto de lamindo',
                description: [
                    'Laminado incorrecto. ',
                    'Lineas en laminado.',
                    'Atoramiento de hoja. ',
                ]
            },
            {
                name: 'Set up',
                description: [
                    'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
                ]
            },
            {
                name: 'Materiales',
                description: [
                    'Defecto de laminado'
                ]
            },
            {
                name: 'Defecto en aplicación',
                description: [
                    'Laminado dañado durante el proceso'
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Perdida de orden y/o job fisico en proceso',
                    'Impresiones dañadas durante el proceso',
                    'Perdida de orden y/o job fisico en proceso'
                ]
            }
        ]        
    },
    'Smart Slitter' : {
        name : 'Smart Slitter',
        problem: [
            {
                name: 'Defecto de corte',
                description: [
                    'Descentrado'
                ]
            },
            {
                name: 'Materiales',
                description: [
                    'Atoramiento'
                ]
            },
            {
                name: 'Estetico',
                description: [
                    'Daño material (tinta negra)'
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Impresiones dañadas durante el proceso',
                    'Perdida de orden y/o job fisico en proceso'
                ]
            },
            {
                name: 'Set up',
                description: [
                    'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
                ]
            },
        ]        
    },
    // 'Graphical Wizard' : {
    //     name : 'Graphical Wizard',
    //     problem: [
    //         {
    //             name: 'Defecto de corte',
    //             description: [
    //                 'Descentrado'
    //             ]
    //         },
    //         {
    //             name: 'Materiales',
    //             description: [
    //                 'Atoramiento'
    //             ]
    //         },
    //         {
    //             name: 'Estetico',
    //             description: [
    //                 'Daño material (tinta negra)'
    //             ]
    //         },
    //         {
    //             name: 'Set up',
    //             description: [
    //                 'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
    //             ]
    //         },
    //     ]        
    // },
    // 'Graphtec' : {
    //     name : 'Graphtec',
    //     problem: [
    //         {
    //             name: 'Materiales',
    //             description: [
    //                 'Atoramiento'
    //             ]
    //         },
    //         {
    //             name: 'Defecto de corte',
    //             description: [
    //                 'Navaja dañada - Desgaste',
    //                 'Presion incorrecta',
    //                 'Posicion incorrecta en Kisscut',
    //                 'Posicion incorrecta en Die cut'
    //             ]
    //         },
    //         {
    //             name: 'Set up',
    //             description: [
    //                 'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
    //             ]
    //         },
    //         {
    //             name: 'Defecto de corte',
    //             description: [
    //                 'Archivo AI incorrecto (Imposicion no coincide con archivo de corte)'
    //             ]
    //         },
    //     ]        
    // },
    'Coater' : {
        name : 'Coater',
        problem: [
            {
                name: 'Estetico',
                description: [
                    'Material ondulado'
                ]
            },
            {
                name: 'Materiales',
                description: [
                    'Atoramiento'
                ]
            },
            {
                name: 'Set up',
                description: [
                    'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
                ]
            },
            {
                name: 'Coating',
                description: [
                    'Mala aplicacion del recubrimiento (No se tiene buen curado)',
                    'Faltante de recubrimiento'
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Perdida de orden y/o job fisico en proceso'
                ]
            }
        ]        
    },
    'Guillotina' : {
        name : 'Guillotina',
        problem: [
            {
                name: 'Defecto de corte',
                description: [
                    'Corte incorrecto (Desalineado / descentrado)'
                ]
            },
            {
                name: 'Estetico',
                description: [
                    'Goma en producto'
                ]
            },
            {
                name: 'Defecto de corte',
                description: [
                    'Desprendimiento de PADS'
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Perdida de orden y/o job fisico en proceso'
                ]
            }
        ]        
    },
    'Ponchadora' : {
        name : 'Ponchadora',
        problem: [
            {
                name: 'Defecto de corte',
                description: [
                    'Ponchado incorrecto (Desalineado / descentrado)',
                    'Ponchado con dimension incorrecta'
                ]
            },
            {
                name: 'Set up',
                description: [
                    'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Perdida de orden y/o job fisico en proceso'
                ]
            }
        ]        
    },
    'Versafire' : {
        name : 'Versafire',
        problem: [
            {
                name: 'Defecto de impresion',
                description: [
                    'Defecto de impresion toner Yellow',
                    'Defecto de impresion toner Magenta',
                    'Defecto de impresion toner Cyan',
                    'Defecto de impresion toner Negro',
                    'Defecto de impresion transfer belt',
                    'Defecto de impresion Fusor ',
                    'Diferencia de tono',
                    'Rayas en impresión',
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Perdida de orden y/o job fisico en proceso'
                ]
            }
        ]
    },
    //Printer is no longer on production floor
    // 'OKI' : {
    //     name : 'OKI',
    //     problem: [
    //         {   
    //             name: 'Defecto de impresion',
    //             description: [
    //                 'Defecto de impresion BID Yellow',
    //                 'Defecto de impresion BID Magenta',
    //                 'Defecto de impresion BID Cyan',
    //                 'Defecto de impresion BID Negro',
    //                 'Defecto de impresion transfer belt',
    //                 'Defecto de impresion Fusor',
    //                 'Diferencia de tono',
    //                 'Rayas en impresión',
    //             ]
    //         },
    //         {
    //             name: 'Proceso',
    //             description: [
    //                 'Perdida de orden y/o job fisico en proceso'
    //             ]
    //         }
    //     ]        
    // },
    'SEI LASER' : {
        name : 'SEI LASER',
        problem: [
            {   
                name: 'Defecto de corte',
                description: [
                    'Programa de corte incorrecto',
                    'Falla de prueba de ajedrez',
                    'Corte profundo - Liner perforado',
                    'Tipo de corte mezclado en el trabajo (Laser/Horizon)',
                    'Falta de corte en toda la hoja / diseño',
                    'Corte decentrado'
                ]
            },
            {   
                name: 'Materiales',
                description: [
                    'Atoramiento feeder',
                    'Atoramiento en unidad laser',
                    'Atoramiento en stacker'
                ]
            },
            {   
                name: 'Set up',
                description: [
                    'Hojas de prueba y ajuste adicionales (Set up incorrecto)'
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Impresiones dañadas durante el proceso',
                    'Perdida de orden y/o job fisico en proceso'
                ]
            }
        ]        
    },
    'Sistema' : {
        name : 'Sistema',
        problem: [
            {   
                name: 'Defecto de corte',
                description: [
                    'Imposicion incorrecta - Templates desalienados',
                    'Descripcion incorrecta del dado en sistema'
                ]
            },
            {   
                name: 'Defecto de impresion',
                description: [
                    'Tono diferente por sistema / diseño - archivo'
                ]
            },
            {
                name :'Dirección',
                description: [
                    'Dirección invalida',
                    'Validación de fechas de envio y fechas de entrega'
                ]
            },
            {
                name: 'Proceso',
                description: [
                    'Estatus NULL de impresión en Prensa'
                ]
            }
        ]        
    },
    'Customer Service' : {
        name : 'Customer Service',
        problem: [
            {
                name: 'Diseño de cliente',
                description: [
                    'Falta de informacion en clear, metalico & kraft',
                    'Imagen con baja resolucion',
                    'Desalineacion de texto y/o imagenes',
                    'Falla en la lectura del barcode',
                    'Marcos/lineas en diseño',
                    'Imagen y/o texto en blanco para clear, metalico & kraft',
                    'Imagen y/o texto invertido',
                    'Imagen en la parte superior o lado izquierdo de la tarjeta ',
                    'Letras delgadas/pequeñas',
                    'Imagen y/o texto del mismo color que el fondo',
                    'Texto encimado sobre texto y/o imagen',
                    'Imagen y/o texto en el trim',
                    'Imagen y/o texto en el bleed',
                    'Imagen y/o texto en el safe',
                    'Hojas Faltantes',
                    'Editado'
                ]
            }
        ]
    },
    'Prepress' : {
        name : 'Prepress',
        problem: [
            {
                name: 'Proceso',
                description: [
                    'Sticker detenidas por demasido tiempo en sistema',
                    'Ajuste de White underprint'
                ]
            }
        ]
    },
    'Empaque' : {
        name : 'Empaque',
        problem: [
            {
                name: 'Proceso',
                description: [
                    'Incorrectamente asignada en Hold',
                    'Orden empacada y sin movimiento por mucho tiempo'
                ]
            }
        ]
    },
    'Otros' : {
        name : 'Otros',
        problem: [
            {
                name: 'Materiales',
                description: [
                    'Material fuera de spec (defectuoso)',
                ]
            },
            {
                name: 'Estetico',
                description: [
                    'Puntos, grasa, aceite, rayas, impresion defectuosa…',
                    'Producto dañado - Roto, doblado, arrugado…',
                ]
            },
            
        ]
    },
    'Produccion/Production' : {
        name : 'Produccion/Production',
        problem: [
            {
                name: 'Articulos perdidos',
                description: [
                    'Cantidad incorrecta de lineas / hojas',
                    'Perdida de orden y/o job fisico en proceso'
                ]
            }
        ]
    },
    'Planeación' : {
        name: 'Planeación',
        problem: [
            {
                name: 'Materiales',
                description: [
                    'Material corto proveedor',
                    'Alta demanda cuasando corto de material',
                ]
            }
        ]
    },
    'Cuarto de dados' : {
        name: 'Cuarto de dados',
        problem: [
            {
                name: 'Herramental',
                description: [
                    'Dado en transito (por daño en proceso)',
                    'Dado en transito (por desgaste)',
                ]
            }
        ]
    }
};



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reprint-reasons.ts